import { Smartphone } from "lucide-react";
import { FilterCategory } from "../config";

export const contactsFilterCategory = {
  title: "Kontaktpersoner",
  id: "contacts",
  icon: Smartphone,
  description: "Virksomhedens kontaktpersoner",
  filters: {},
  isAdvancedFilter: true,
} satisfies FilterCategory;
